
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document/intro",
      function () {
        return require("private-next-pages/document/intro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document/intro"])
      });
    }
  